export const bolepidemiologicos2026 = [
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- Diabetes",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/Diabetes/Boletin Anual de Diabetes 2025.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- EDA",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/EDA/Boletin Epidemiologico de EDA 2025.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- ESAVI",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/ESAVI/Boletin Epidemiologico de Eventos Supuestamente Atribuibles a la Vacunacion o inmunizacion.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- EPV",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/EPV/Boletin Epidemiologico de EPV 2025.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- ETV",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/ETV/Boletin Enfermedades Parasitarias y Bacterianas Transmitidas por Vector.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- TNE",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/TNE/Boletin epidemiologico de TNE.pdf"
  //   ,
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- Tuberculosis",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/Tuberculosis/Boletin Epidemiologico de TB Todas las Formas.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- VIH",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/VIH/Boletin Epidemiologico VIH 2025.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Anual- ERV",
  //   "url_elemento":"../../../contenido/epidemiologia/2025/ERV/Boletin Anual Epidemiologico ERV 2025.pdf",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Semanal - Arbovirosis",
  //   "url_elemento":"/Transparencia/Epidemiologico/Boletines2025/Arbovirosis",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Semanal - Convencional (SUIVE)",
  //   "url_elemento":"/Transparencia/Epidemiologico/Epidemiologico2025",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Semanal - Monitoreo de Medios",
  //   "url_elemento":"/Transparencia/Epidemiologico/Boletines2025/Monitoreo",
  // },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Trimestral - DAN",
  //   "url_elemento":"/Transparencia/Epidemiologico/Boletines2025/DAN",
  // },
  {
    "etiqueta_elemento": "Boletín Epidemiológico Mensual - IAAS",
    "url_elemento":"/Transparencia/Epidemiologico/Boletines2026/IAAS",
  },
  // {
  //   "etiqueta_elemento": "Boletín Epidemiológico Trimestral - MMEG",
  //   "url_elemento":"/Transparencia/Epidemiologico/Boletines2025/MMEG",
  // },
]